var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WalletTransferLimitContent',_vm._b({},'WalletTransferLimitContent',_vm.componentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }